/* eslint-disable */
const moment = require('moment-timezone');
const paper = require('paper/dist/paper-core');
const WORK_TEMPLATE_NAME = "WorkTemplate";

class WhiteboardLib{
  constructor(settings, canvas, events){

    // Create an empty project and a view for the canvas:
    paper.setup(canvas);

    // Draw the view now:
    paper.view.draw();

    this.settings = settings;
    this.canvas = canvas;
    this.paper = paper;

    this.toolStack = this.initToolstack();
    this.toolStack.activateTool('toolPath');
    this.events = events;

    // for temporary content we block the modified event recevier on the frontend
    // everytime a new temporary item is set, we wait at least for it's timeout before reloading the frontend view
    this.blockModifiedUntil = null;
    this.modalButtonPressed = null;
  }

  importJSON(data){
    paper.project.clear();
    let result = paper.project.importJSON(data);
    //this.resizeForWorkTemplate();
    return result;
  }

  exportJSON(){
    return paper.project.exportJSON({asString: false});
  }

  cleanupTools(){
    if(this.toolStack){
      this.toolStack.cleanupTools();
    }
  }

  // try to find a work template and set the zoom factor for it.
  resizeForWorkTemplate(){
    //UNUSED!
    let workTemplate = paper.project.activeLayer.children[WORK_TEMPLATE_NAME];

    if(!workTemplate || !paper.view.viewSize){
      return;
    }

    console.log("RESIZING Canvas size", paper.view.viewSize );
    console.log("RESIZING Template size", workTemplate.bounds);

    let scaleX = workTemplate.bounds.width / paper.view.viewSize.width;
    let scaleY = workTemplate.bounds.height / paper.view.viewSize.height;

    console.log("zoom", scaleX, scaleY)
    paper.view.zoom = scaleX < scaleY ? scaleX : scaleY;
  }

  callOnModifiedEvent(){
    if(this.events && this.events.onModified){
      console.log("Whiteboard modified event");
      this.events.onModified();
    }
  }

  isModifiedBlocked(){
    console.log('blocked until', this.blockModifiedUntil)
    if(this.blockModifiedUntil){
      return new moment() <= this.blockModifiedUntil;
    }

    return false;
  }

  initToolstack(){

    const self = this;

    // Create a simple drawing tool:
    const toolPath = () => {
      const tool = new paper.Tool();
      tool.name = 'toolPath';
      tool.minDistance = 5;
      let path;

      tool.onMouseDown = function(event){

        // unselect possible old path
        if (path){
          path.selected = false;
        }

        path = new paper.Path();
        path.strokeColor = self.settings.color;
        path.fullySelected = true;
        path.strokeWidth = 2 * self.settings.line;
        path.add(event.point)
      }

      tool.onMouseDrag = function(event){
        path.add(event.point);
      }

      tool.onMouseUp = function(event){
        path.selected=false;
        //path.smooth();
        path.simplify();

        self.callOnModifiedEvent();
      }

      return tool;
    };

    const toolDelete = () => {
      const tool = new paper.Tool();
      tool.name = 'toolDelete';

      let selectedItem;

      tool.onMouseDown = function(event){
        console.log('toolDelete Event')
      }

      tool.onMouseMove = function(event){
        let hit = paper.project.hitTest(event.point);

        if(hit && (hit.type == "stroke" || hit.type == 'fill')){
          hit.item.selected = true;
          selectedItem = hit.item;
        }
        else{
          if(hit){
            console.log("HIT", hit);
          }
          if(selectedItem){
            selectedItem.selected = false;
          }
          selectedItem = null;
        }
      }

      tool.onMouseDrag = function(event){
        let hit = paper.project.hitTest(event.point);
        if(hit && (hit.type == "stroke" || hit.type == 'fill')){
          hit.item.remove();
          self.callOnModifiedEvent();
        }
      }

      return tool;
    };

    const toolMark = () => {
      //todo: in another layer ?
      const tool = new paper.Tool();
      tool.name = 'toolMark';

      let paths = [];
      let timeout;

      tool.cleanUp = function(){
        console.log('cleanup');

        for(let path of paths){
          console.log('remove path', path);
          path.remove();
        }
        paths = [];

        if(timeout){
          clearTimeout(timeout);
        }
      };

      tool.onMouseDown = function(event) {

        let path = new paper.Path.Circle({
          center: event.point,
          radius: 10,
          fillColor: '#9C27B0',
        });

        self.blockModifiedUntil = new moment().add(3,'seconds'),

          paths.push(path);
        self.callOnModifiedEvent();

        timeout = setTimeout(()=>{
          let path = paths.shift();
          if(path){
            path.remove();
            self.callOnModifiedEvent();
          }
        },3000);
      };

      return tool
    };

    const toolZoomIn = () => {
      const tool = new paper.Tool();
      tool.name = 'toolZoomIn';

      tool.onMouseDown = function(event){
        paper.view.zoom += 0.2;
      }

      return tool;
    };

    const toolZoomOut = () => {
      const tool = new paper.Tool();
      tool.name = 'toolZoomOut';

      tool.onMouseDown = function(event){
        paper.view.zoom -= 0.2;
      }

      return tool;
    };

    const toolMove = () => {
      const tool = new paper.Tool();
      tool.name = 'toolMove';

      let deltaX = 0;
      let deltaY = 0;

      tool.onMouseDrag = function(event){
        deltaX += event.delta.x;
        deltaY += event.delta.y;

        if( Math.abs(deltaX) > 15 || Math.abs(deltaY) > 15){
          paper.view.setCenter(paper.view.center.x - deltaX, paper.view.center.y - deltaY);
          deltaX = 0;
          deltaY = 0;
        }


      }

      return tool;
    };

    const toolText = () => {
      const tool = new paper.Tool();
      tool.name = 'toolText';
      let self = this;

      let selectedItem;
      let wasADrag = false;
      let isDialogOpen = false;

      tool.onMouseMove = function(event){

        let hit = paper.project.hitTest(event.point);

        // Do not modify selectedItem if a dialog is open, otherwise we can change the wrong item with an unlucky mouse move
        // But only on hit
        /*if(isDialogOpen && hit) {
            return;
        }*/

if( hit && (hit.type == "stroke" || hit.type == 'fill')){
  hit.item.selected = true;
  selectedItem = hit.item;
}
else{
  if(hit){
    console.log("HIT", hit);
  }

  if(selectedItem){
    selectedItem.selected = false;
  }
  selectedItem = null;
}
}

tool.onMouseDrag = function(event){
  if(!selectedItem){
    return;
  }
  selectedItem.position = event.point;
  wasADrag = true;
};

tool.onMouseDown = function(event){
  wasADrag = false; //to detect difference between "click to edit" and "move"

  if(selectedItem){
    return;
  }

  //self.template.$("#modal-edit-text input[name*='textInput']").val("");

  let currentSize=/*Number($("#modalInputTextSize").val()) ||*/ 20;
  console.log(currentSize);
  let checkBox = `.form-check-input[data-size='${currentSize}']`;
  if (checkBox) {
    // $(checkBox).prop('checked', true);
  }

  //self.template.$("#modal-edit-text").modal('show');

  //self.template.$('#modal-edit-text').off('hidden.bs.modal'); //unbind event first, otherwise we have duplication effects
  //isDialogOpen = true;

  /*
  self.template.$('#modal-edit-text').on('hidden.bs.modal', function (e) {
    let action = self.modalButtonPressed;
    let size = Number($("#modalInputTextSize").val()) || 20;

    let textValue = 'TEST'; //$("input[name*='textInput']").val();
    let text = new paper.PointText(event.point);

    switch (action) {
      case 'save':
        text.content = textValue;
        text.style = {
          fontFamily: 'Arial',
          fontWeight: 'bold',
          fontSize: size,
          fillColor: 'black',
          justification: 'center'
        }
        self.callOnModifiedEvent();
        break;
      default:
        break;
    }

    self.modalButtonPressed = null;
    //isDialogOpen = false;
  });
*/

  /*Meteor.setTimeout(function(){
    $("input[name*='textInput']").focus();
  },700);*/
}

tool.onMouseUp = function(event) {
  if(selectedItem && !wasADrag){
    console.log(selectedItem);
    let selectedItemBackup = selectedItem; // because selectedItem may change during mouse move, we need it to modify the content
    //self.template.$("#modal-edit-text input[name*='textInput']").val(selectedItem.content);

    let currentSize=selectedItem.fontSize;
    let checkBox = `.form-check-input[data-size='${currentSize}']`;
    if (checkBox) {
      // $(checkBox).prop('checked', true);
    }

    // self.template.$("#modal-edit-text").modal('show');
    //isDialogOpen = true;

    // self.template.$('#modal-edit-text').off('hidden.bs.modal'); //unbind event first, otherwise we have duplication effects

    /*
    self.template.$('#modal-edit-text').on('hidden.bs.modal', function (e) {
      let action = self.modalButtonPressed;

      let textValue = 'TEST';
      let size = 20;

      switch (action) {
        case 'save':
          selectedItemBackup.content = textValue;
          selectedItemBackup.fontSize = size;
          self.callOnModifiedEvent();
          break;
        default:
          break;
      }

      self.modalButtonPressed = null;
      //isDialogOpen = false;
    }); */
  }
};

return tool;
};

return new ToolStack([toolPath, toolDelete, toolMark, toolZoomIn, toolZoomOut, toolMove, toolText]);
}

clearProject(){
  paper.project.clear();
}

loadBackgroundImage(path){
  if(!path){
    return;
  }

  let self = this;

  for(let item of paper.project.activeLayer.children){
    console.log(item, item.name);
    if(item.name === WORK_TEMPLATE_NAME){
      // toastr.warning(TAPi18n.__('whiteboard.warningExistingWorkTemplate'));
      //alert("Es gibt bereits eine Arbeitsvorlage auf dem Board.");
      return;
    }
  }

  let raster = new paper.Raster(path);
  raster.name=WORK_TEMPLATE_NAME;

  //raster.scale(0.1);
  //raster.rotate(45);
  //raster.position = paper.view.bounds;
  raster.onLoad = function () {
    console.log('onload');
    let xScale = paper.view.bounds.width / this.bounds.width;
    let yScale = paper.view.bounds.height / this.bounds.height;
    let scale = xScale < yScale ? xScale : yScale;

    //this.bounds.width = window.paper.view.bounds.width;
    //this.bounds.height = window.paper.view.bounds.height;
    this.scale(scale);

    //this.bounds.height = window.paper.view.bounds.height;
    //this.position = new paper.Point(0,0);
    this.position = paper.view.center;
    self.callOnModifiedEvent();
  }
}

undo(){
  if(!this.redoList){
    this.redoList = [];
  }
  let undo = paper.project.activeLayer.children.pop();
  if (undo){
    this.redoList.push(undo);
    this.callOnModifiedEvent();
    return true;
  }

  return false;
}

redo(){
  if(this.redoList){
    let redo = this.redoList.pop();
    if(redo){
      paper.project.activeLayer.children.push(redo);
      this.callOnModifiedEvent();
      return true;
    }
  }

  return false;
}

zoomIn(){
  if(paper.view.zoom < 3){
    paper.view.zoom += 0.2;
  }
}

zoomOut(){
  if(paper.view.zoom > 0.3){
    paper.view.zoom -= 0.2;
  }
}

centerContent(){

  let farLeft = 999999;
  let farRight = -999999;
  let farTop = 999999;
  let farBottom = -999999;

  for(let item of paper.project.activeLayer.children){
    if(item.position.x < farLeft){
      farLeft = item.position.x;
    }

    if(item.position.x > farRight){
      farRight = item.position.x;
    }

    if(item.position.y < farTop){
      farTop = item.position.y;
    }

    if(item.position.y > farBottom){
      farBottom = item.position.y;
    }
  }

  console.log("fars", farLeft, farRight, farTop, farBottom);
  console.log("center", paper.view.center);
  console.log("view", paper.view);

  paper.view.setCenter( farLeft + (farRight-farLeft) / 2 ,farTop + (farBottom - farTop) / 2);
}
}

// PaperJS Tool stack
class ToolStack {
  constructor(tools) {
    console.log("INIT TOOLSTACK", tools);
    this.tools = tools.map(tool => tool())
    console.log("TOOLS AFTER INIT", this.tools);
    this.activeTool = null;
    this.generateTooLIcons();
  }

  activateTool(name) {
    console.log('ACTIVATE TOOL', name);

    //this.cleanupTools();

    const tool = this.tools.find(tool => tool.name === name);
    tool.activate();
    this.activeTool = tool;
  }

  cleanupTools(){
    //fix: remove scheduled items
    if( this.activeTool && this.activeTool.name === "toolMark"){
      try{
        this.activeTool.cleanUp();
      }
      catch(e){
        console.log("Error in tool cleanup", e);
      }
    }
  }

  getIconForTool(tool){
    console.log("GetICONFORTOOL", tool);
    switch (tool) {
      case 'toolPath':
        return 'mdi-pencil';
      case 'toolDelete':
        return 'mdi-eraser';
      case 'toolMark':
        return 'mdi-cursor-pointer';
      case 'toolZoomIn':
        return 'fa fa-search-plus';
      case 'toolZoomOut':
        return 'fa fa-search-minus';
      case 'toolMove':
        return 'fa fa-arrows';
      case 'toolText':
        return "fa fa-font";

      default:
        return null;
    }
  }

  getCursorForTool(tool){
    if(!tool || !this.toolIcons[tool]){
      return null;
    }

    return 'cursor: ' + this.toolIcons[tool] + ';';
  }

  generateIconByFontAwesome(icon){
    let canvas = document.createElement("canvas");
    canvas.width = 24;
    canvas.height = 24;
    //document.body.appendChild(canvas);
    let ctx = canvas.getContext("2d");
    ctx.fillStyle = "#000000";
    ctx.font = "24px FontAwesome";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(icon, 12, 12);
    let dataURL = canvas.toDataURL('image/png')
    return 'url('+dataURL+'), auto';
    //$('body').css('cursor', 'url('+dataURL+'), auto');
  }

  generateTooLIcons = function(){
    if(!this.toolIcons){
      this.toolIcons = {};

      //this.toolIcons['toolPath'] = generateIconByFontAwesome("\uf040");
      //this.toolIcons['toolPath'] = generateIconByFontAwesome("\uf304");
      this.toolIcons['toolDelete'] = 'crosshair;';//generateIconByFontAwesome("\uf12d");
      this.toolIcons['toolMark'] = 'pointer;'//generateIconByFontAwesome("\uf0a6");
      this.toolIcons['toolZoomIn'] = 'zoom-in;'//generateIconByFontAwesome("\uf0a6");
      this.toolIcons['toolZoomOut'] = 'zoom-out;'//generateIconByFontAwesome("\uf0a6");
      this.toolIcons['toolMove'] = 'move;'//generateIconByFontAwesome("\uf0a6");
    }
  };

}

export {WhiteboardLib}
